/* The Core Loafers landing page — Quick Shop, rails, filter/sort, drop alert, colour validation */
(function () {
  'use strict';
  var root = document.getElementById('bwcl');
  if (!root) return;

  var DATA = {};
  try { DATA = JSON.parse(document.getElementById('bwcl-data').textContent); } catch (e) { DATA = {}; }
  var PRODUCTS = DATA.products || {};
  delete PRODUCTS._;
  var CACHE = {};            // handle -> product data | null (not published)
  Object.keys(PRODUCTS).forEach(function (h) { CACHE[h] = PRODUCTS[h]; });

  var mqMobile = window.matchMedia('(max-width: 767px)');
  var BAG_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M5 8h14l-1 13H6L5 8z"></path><path d="M9 8V6a3 3 0 0 1 6 0v2"></path></svg>';

  function $(s, el) { return (el || root).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function' && DATA.moneyFormat) {
        return Shopify.formatMoney(cents, DATA.moneyFormat).replace(/\.00(?=\D*$)/, '');
      }
    } catch (e) {}
    var v = (cents || 0) / 100;
    return '$' + (v % 1 ? v.toFixed(2) : String(v)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ---------- product data (inline, or ?view=core-loafers-data for colour siblings) ---------- */
  var pending = {};
  function getProduct(h) {
    if (h in CACHE) return Promise.resolve(CACHE[h]);
    if (pending[h]) return pending[h];
    pending[h] = fetch('/products/' + encodeURIComponent(h) + '?view=core-loafers-data', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('nf'); return r.text(); })
      .then(function (t) { var d = JSON.parse(t); CACHE[h] = (d && d.handle) ? d : null; return CACHE[h]; })
      .catch(function () { CACHE[h] = null; return null; });
    return pending[h];
  }
  // Only colourways that are published to the Online Store and in stock (the current product always stays)
  function liveColors(p) {
    var list = (p.colors || []);
    return Promise.all(list.map(function (c) { return getProduct(c.h); })).then(function (res) {
      return list.filter(function (c, i) { return !!res[i] && (i === 0 || res[i].available); });
    });
  }

  /* ---------- sole versions (handle X <-> X-lug-sole / X-vibram-1757-lug-sole) ---------- */
  var SOLE_IMG = { black: 'https://cdn.shopify.com/s/files/1/1028/8463/9042/files/bwwel_sole_black.jpg?width=300', brown: 'https://cdn.shopify.com/s/files/1/1028/8463/9042/files/bwwel_sole_brown.jpg?width=300' };
  function resolveSoles(p) {
    var h = p.handle, out;
    if (/-vibram-1757-lug-sole$/.test(h) || /-lug-sole$/.test(h)) {
      var vib = /-vibram-1757-lug-sole$/.test(h);
      return getProduct(h.replace(vib ? /-vibram-1757-lug-sole$/ : /-lug-sole$/, '')).then(function (lp) {
        return (lp && lp.available) ? { leather: lp, lug: p, type: vib ? 'vibram' : 'weber' } : null;
      });
    }
    return getProduct(h + '-lug-sole').then(function (a) {
      if (a) return { leather: p, lug: a, type: 'weber' };
      return getProduct(h + '-vibram-1757-lug-sole').then(function (b) { return b ? { leather: p, lug: b, type: 'vibram' } : null; });
    }).then(function (s) { return (s && s.lug.available) ? s : null; });
  }
  function prepare(p) { return Promise.all([liveColors(p), resolveSoles(p)]); }
  function preload(src) {
    return new Promise(function (res) {
      if (!src) return res();
      var i = new Image(), t = setTimeout(res, 1500);
      i.onload = i.onerror = function () { clearTimeout(t); res(); };
      i.src = src;
    });
  }

  /* ---------- verify colour counts + dots on the page ---------- */
  function fmtCount(n, fmt) {
    if (fmt === 'long') return n + (n === 1 ? ' Color Available +' : ' Colors Available +');
    return n + (n === 1 ? ' color' : ' colors');
  }
  function verifyColors() {
    Object.keys(PRODUCTS).forEach(function (h) {
      var p = PRODUCTS[h];
      resolveSoles(p);
      liveColors(p).then(function (cols) {
        p.liveColors = cols;
        $$('[data-bwcl-count="' + h + '"]').forEach(function (el) { el.textContent = fmtCount(cols.length, el.getAttribute('data-fmt')); });
        var dots = $('[data-bwcl-dots="' + h + '"]');
        if (dots) {
          var ok = {}; cols.forEach(function (c) { ok[c.h] = 1; });
          $$('.bwcl-dot', dots).forEach(function (d) { if (!ok[d.getAttribute('data-h')]) d.remove(); });
          var have = $$('.bwcl-dot', dots).length, n = dots.querySelector('.bwcl-dots__n');
          cols.forEach(function (c) {
            if (have >= 4 || dots.querySelector('[data-h="' + c.h + '"]')) return;
            var s = document.createElement('span');
            s.className = 'bwcl-dot'; s.setAttribute('data-h', c.h); s.title = c.n; s.style.backgroundImage = 'url(' + c.sw + ')';
            dots.insertBefore(s, n); have++;
          });
        }
      });
    });
  }
  if ('requestIdleCallback' in window) window.requestIdleCallback(verifyColors, { timeout: 1500 }); else setTimeout(verifyColors, 600);

  /* ---------- theme cart sync ---------- */
  function refreshThemeCart(count) {
    try {
      var w = document.querySelector('.cart__item-count-wrapper');
      var st = w && w.__vue__ && w.__vue__.$store;
      if (st && st._actions && st._actions['Cart/getCart']) st.dispatch('Cart/getCart');
    } catch (e) {}
    if (typeof count === 'number') {
      Array.prototype.forEach.call(document.querySelectorAll('.cart__item-count'), function (el) { el.textContent = count; });
    }
    try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
  }

  /* ---------- Quick Shop ---------- */
  var qs = null, state = null, lastFocus = null, addedTimer = null;

  function buildShell() {
    qs = document.createElement('div');
    qs.className = 'bwcl bwcl-qs';
    qs.hidden = true;
    qs.innerHTML = '<div class="bwcl-qs__ov" data-bwcl-close></div>' +
      '<div class="bwcl-qs__panel" role="dialog" aria-modal="true" aria-label="Quick Shop" tabindex="-1"></div>';
    document.body.appendChild(qs);
    qs.addEventListener('click', onQsClick);
    qs.addEventListener('keydown', onQsKey);
  }

  function open(handle, worn, wornImg) {
    var p = CACHE[handle] || PRODUCTS[handle];
    if (!p) return false;
    if (!qs) buildShell();
    lastFocus = document.activeElement;
    state = { origin: handle, p: p, worn: worn || '', wornImg: wornImg || '', size: null, view: 'shop', busy: false, added: false, err: '', colors: null, soles: null, line: null, cart: null };
    render();
    qs.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var panel = qs.querySelector('.bwcl-qs__panel');
    setTimeout(function () { var x = panel.querySelector('.bwcl-qs__x'); (x || panel).focus({ preventScroll: true }); }, 30);
    prepare(p).then(function (r) { if (state && state.p === p) { state.colors = r[0]; state.soles = r[1]; renderColors(); renderSoles(); } });
    return true;
  }
  function close() {
    if (!qs || qs.hidden) return;
    qs.hidden = true;
    document.documentElement.style.overflow = '';
    clearTimeout(addedTimer);
    state = null;
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  function sizeLabel() { return state.size ? state.size.t : 'Select'; }

  function colorsHtml() {
    var p = state.p, cols = state.colors || [{ n: p.color, h: p.handle, sw: (p.colors && p.colors[0] && p.colors[0].sw) || '' }];
    return cols.map(function (c) {
      var on = c.h === p.handle;
      return '<button type="button" class="bwcl-sw' + (on ? ' on' : '') + '" data-bwcl-color="' + esc(c.h) + '" aria-label="' + esc(c.n) + '" aria-pressed="' + on + '" title="' + esc(c.n) + '" style="background-image:url(' + esc(c.sw) + ')"></button>';
    }).join('');
  }
  function renderColors() {
    if (!qs || !state || state.view !== 'shop') return;
    var el = qs.querySelector('.bwcl-sws'); if (el) el.innerHTML = colorsHtml();
    var c = qs.querySelector('[data-bwcl-ccount]');
    if (c && state.colors) c.textContent = '· ' + state.colors.length + (state.colors.length === 1 ? ' color' : ' colors');
  }

  function solesHtml() {
    var s = state.soles, p = state.p;
    if (!s) return '';
    var onLug = p.handle === s.lug.handle;
    var black = /onyx|black/i.test(p.handle + ' ' + (p.color || ''));
    var lugLabel = s.type === 'vibram' ? 'Vibram Lug Sole' : 'Weber Lug Sole';
    var lugImg = s.type === 'vibram' ? (s.lug.soleImg || '') : (black ? SOLE_IMG.black : SOLE_IMG.brown);
    function pill(prod, label, img, mod, on) {
      return '<button type="button" class="bwcl-sole bwcl-sole--' + mod + (on ? ' on' : '') + '" data-bwcl-sole="' + esc(prod.handle) + '" aria-pressed="' + on + '">' +
        '<span class="bwcl-sole__img" aria-hidden="true">' + (img ? '<img src="' + esc(img) + '" alt="">' : '') + '</span><span class="bwcl-sole__t">' + esc(label) + '</span></button>';
    }
    return '<div class="bwcl-qs__grp"><span class="bwcl-eyebrow bwcl-qs__lbl">Sole: <span class="v">' + (onLug ? lugLabel : 'Leather Sole') + '</span></span>' +
      '<div class="bwcl-soles" role="group" aria-label="Sole">' +
      pill(s.leather, 'Leather Sole', s.leather.soleImg || '', 'leather', !onLug) +
      pill(s.lug, lugLabel, lugImg, s.type === 'vibram' ? 'vibram' : 'lug', onLug) + '</div></div>';
  }
  function renderSoles() {
    if (!qs || !state || state.view !== 'shop') return;
    var el = qs.querySelector('[data-bwcl-soles]'); if (el) el.innerHTML = solesHtml();
  }

  function atbHtml() {
    var p = state.p;
    if (state.added) return '<button type="button" class="bwcl-atb is-added" disabled>✓ Added</button>';
    if (state.busy) return '<button type="button" class="bwcl-atb" disabled>Adding…</button>';
    if (!p.available) return '<button type="button" class="bwcl-atb off" disabled>Sold out</button>';
    if (!state.size) return '<button type="button" class="bwcl-atb off" disabled aria-disabled="true">' + BAG_SVG + 'Select a Size</button>';
    return '<button type="button" class="bwcl-atb" data-bwcl-add>' + BAG_SVG + 'Add to Bag · ' + esc(money(state.size.p || p.price)) + '</button>';
  }

  function render() {
    var panel = qs.querySelector('.bwcl-qs__panel');
    qs.classList.toggle('bwcl-qs--shop', state.view === 'shop');
    qs.classList.toggle('bwcl-qs--bag', state.view === 'bag');
    var body = panel.querySelector('.bwcl-qs__body'), bt = body ? body.scrollTop : 0, pt = panel.scrollTop;
    panel.innerHTML = state.view === 'bag' ? bagHtml() : shopHtml();
    var nb = panel.querySelector('.bwcl-qs__body'); if (nb && state.view === 'shop') nb.scrollTop = bt;
    panel.scrollTop = pt;
    panel.setAttribute('aria-label', state.view === 'bag' ? 'Your Bag' : 'Quick Shop');
  }

  function shopHtml() {
    var p = state.p;
    var sizes = (p.variants || []).map(function (v) {
      var on = state.size && state.size.id === v.id;
      return '<button type="button" class="bwcl-sz' + (on ? ' on' : '') + '" data-bwcl-size="' + v.id + '"' + (v.a ? '' : ' disabled aria-label="Size ' + esc(v.t) + ', sold out"') + ' aria-pressed="' + !!on + '">' + esc(v.t) + '</button>';
    }).join('');
    var worn = (state.worn && p.handle === state.origin) ?
      '<span class="bwcl-qs__worn">' + (state.wornImg ? '<img src="' + esc(state.wornImg) + '" alt="">' : '') + 'As worn by ' + esc(state.worn) + '</span>' : '';
    var badge = p.badge ? '<span class="bwcl-pill">' + esc(p.badge) + '</span>' : '';
    var ccount = state.colors ? '· ' + state.colors.length + (state.colors.length === 1 ? ' color' : ' colors') : '';
    return '<span class="bwcl-qs__grab" aria-hidden="true"></span>' +
      '<div class="bwcl-qs__hd"><span class="bwcl-eyebrow">Quick Shop</span><button type="button" class="bwcl-qs__x" data-bwcl-close aria-label="Close">×</button></div>' +
      '<div class="bwcl-qs__body">' +
        '<div class="bwcl-qs__mhead"><img src="' + esc(p.thumb || p.img) + '" alt="' + esc(p.title) + '"><div>' + (p.badge ? '<span class="bwcl-pill">' + esc(p.badge) + '</span>' : '') +
          '<span class="bwcl-serif bwcl-qs__mh">' + esc(p.name) + '</span><span class="bwcl-qs__msub">' + esc(p.sub) + ' · ' + esc(p.priceFmt) + '</span></div>' +
          '<button type="button" class="bwcl-qs__x" data-bwcl-close aria-label="Close">×</button></div>' +
        '<div class="bwcl-qs__media"><img src="' + esc(p.img) + '" alt="' + esc(p.title) + '">' + badge + worn + '</div>' +
        '<div class="bwcl-qs__titlerow"><div><h3 class="bwcl-serif bwcl-qs__h">' + esc(p.name) + '</h3><span class="bwcl-qs__sub">' + esc(p.sub) + '</span></div><span class="bwcl-qs__price">' + esc(p.priceFmt) + '</span></div>' +
        '<div class="bwcl-qs__grp"><span class="bwcl-eyebrow bwcl-qs__lbl">Color: <span class="v">' + esc(p.color) + '</span> <span class="c" data-bwcl-ccount>' + ccount + '</span></span>' +
          '<div class="bwcl-sws" role="group" aria-label="Color">' + colorsHtml() + '</div></div>' +
        '<div data-bwcl-soles>' + solesHtml() + '</div>' +
        '<div class="bwcl-qs__grp"><div class="bwcl-qs__lblrow"><span class="bwcl-eyebrow bwcl-qs__lbl">Size: <span class="v" data-bwcl-sizelbl>' + esc(sizeLabel()) + '</span></span>' +
          '<a class="bwcl-qs__guide" href="' + esc(p.url) + '">Size Guide</a></div>' +
          '<div class="bwcl-szs" role="group" aria-label="Size">' + sizes + '</div></div>' +
      '</div>' +
      '<div class="bwcl-qs__ft"><div data-bwcl-atb style="width:100%">' + atbHtml() + '</div>' +
        '<p class="bwcl-qs__err" role="alert">' + esc(state.err) + '</p>' +
        '<a href="' + esc(p.url) + '" class="bwcl-btn-text">View Full Details</a></div>';
  }

  function bagHtml() {
    var cart = state.cart || { item_count: 0, total_price: 0, items: [] };
    var line = state.line;
    var item = '';
    if (line) {
      var opt = (line.options_with_values || []).filter(function (o) { return o.name !== 'Title'; }).map(function (o) { return o.name === 'Size' ? 'Size ' + o.value : o.value; }).join(' · ');
      var sub = (state.p && line.product_id && state.p.sub ? state.p.sub : (line.variant_title || '')) + (opt ? ' · ' + opt : '');
      var img = (line.featured_image && line.featured_image.url) || line.image || (state.p && state.p.thumb) || '';
      item = '<div class="bwcl-bag__item"><img src="' + esc(img) + '" alt="">' +
        '<div class="bwcl-bag__info"><span class="bwcl-serif bwcl-bag__t">' + esc(state.p ? state.p.name : line.product_title) + '</span>' +
        '<span class="bwcl-bag__sub">' + esc(sub) + '</span>' +
        '<div class="bwcl-bag__row"><span class="bwcl-qty"><button type="button" data-bwcl-qty="-1" aria-label="Decrease quantity">−</button><span aria-live="polite">' + line.quantity + '</span><button type="button" data-bwcl-qty="1" aria-label="Increase quantity">+</button></span>' +
        '<span class="bwcl-bag__price">' + esc(money(line.final_line_price != null ? line.final_line_price : line.line_price)) + '</span></div></div></div>';
      var others = cart.item_count - line.quantity;
      if (others > 0) item += '<p class="bwcl-bag__more">+ ' + others + ' more item' + (others === 1 ? '' : 's') + ' in your bag</p>';
    } else {
      item = '<p class="bwcl-bag__more">' + (cart.item_count ? 'Item removed.' : 'Your bag is empty.') + '</p>';
    }
    return '<span class="bwcl-qs__grab" aria-hidden="true"></span>' +
      '<div class="bwcl-qs__hd"><span class="bwcl-eyebrow">Your Bag (' + cart.item_count + ')</span><button type="button" class="bwcl-qs__x" data-bwcl-close aria-label="Close">×</button></div>' +
      item +
      '<div class="bwcl-bag__ft"><div class="bwcl-bag__sum"><span>Subtotal</span><span>' + esc(money(cart.total_price)) + '</span></div>' +
      '<span class="bwcl-bag__note">Shipping and taxes calculated at checkout</span>' +
      '<p class="bwcl-qs__err" role="alert">' + esc(state.err) + '</p>' +
      (cart.item_count ? '<a href="/checkout" class="bwcl-atb">Checkout</a>' : '') +
      '<button type="button" class="bwcl-btn-text" data-bwcl-close>Continue Shopping</button></div>';
  }

  function setAtb() {
    var el = qs.querySelector('[data-bwcl-atb]'); if (el) el.innerHTML = atbHtml();
    var er = qs.querySelector('.bwcl-qs__err'); if (er) er.textContent = state.err || '';
  }

  function add() {
    if (!state || !state.size || state.busy) return;
    state.busy = true; state.err = ''; setAtb();
    var p = state.p;
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: state.size.id, quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) {
        var line = (j && j.items && j.items[0]) || j;
        return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
          if (!state || state.p !== p) return;
          state.busy = false; state.added = true; state.cart = cart;
          state.line = (cart.items || []).filter(function (i) { return i.key === line.key; })[0] || line;
          setAtb();
          refreshThemeCart(cart.item_count);
          clearTimeout(addedTimer);
          addedTimer = setTimeout(function () { if (state && state.added) { state.view = 'bag'; render(); var x = qs.querySelector('.bwcl-qs__x'); if (x) x.focus({ preventScroll: true }); } }, 650);
        });
      })
      .catch(function (e) {
        if (!state) return;
        state.busy = false;
        state.err = (e && (e.description || e.message)) ? String(e.description || e.message) : 'Something went wrong. Please try again.';
        setAtb();
      });
  }

  function changeQty(delta) {
    if (!state || !state.line || state.busy) return;
    var q = Math.max(0, state.line.quantity + delta);
    state.busy = true;
    fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: state.line.key, quantity: q }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (cart) {
        if (!state) return;
        state.busy = false; state.err = ''; state.cart = cart;
        state.line = (cart.items || []).filter(function (i) { return i.key === state.line.key; })[0] || null;
        render(); refreshThemeCart(cart.item_count);
      })
      .catch(function (e) { if (!state) return; state.busy = false; state.err = (e && e.description) || 'Could not update quantity.'; render(); });
  }

  function switchTo(h, btn) {
    if (!state || h === state.p.handle || state.switching) return;
    state.switching = true;
    if (btn) btn.setAttribute('aria-busy', 'true');
    var keepSize = state.size ? state.size.t : null;
    getProduct(h).then(function (np) {
      if (!np) return [null];
      return Promise.all([np, prepare(np), preload(np.img)]);
    }).then(function (r) {
      if (!state) return;
      state.switching = false;
      var np = r[0];
      if (!np) { if (btn) { btn.removeAttribute('aria-busy'); if (btn.hasAttribute('data-bwcl-color')) btn.remove(); } return; }
      state.p = np; state.colors = r[1][0]; state.soles = r[1][1]; state.added = false; state.err = '';
      var match = keepSize && (np.variants || []).filter(function (v) { return v.t === keepSize && v.a; })[0];
      state.size = match || null;
      render();
      var sel = btn && btn.hasAttribute('data-bwcl-sole') ? '[data-bwcl-sole="' + h + '"]' : '[data-bwcl-color="' + h + '"]';
      var nb = qs.querySelector(sel); if (nb) nb.focus({ preventScroll: true });
    });
  }

  function onQsClick(e) {
    var t = e.target;
    if (t.closest('[data-bwcl-close]')) { e.preventDefault(); close(); return; }
    var sz = t.closest('[data-bwcl-size]');
    if (sz && !sz.disabled) {
      var id = Number(sz.getAttribute('data-bwcl-size'));
      state.size = (state.p.variants || []).filter(function (v) { return v.id === id; })[0] || null;
      state.added = false; state.err = '';
      Array.prototype.forEach.call(qs.querySelectorAll('.bwcl-sz'), function (b) { var on = b === sz; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on); });
      var l = qs.querySelector('[data-bwcl-sizelbl]'); if (l) l.textContent = sizeLabel();
      setAtb(); return;
    }
    if (t.closest('[data-bwcl-add]')) { add(); return; }
    var col = t.closest('[data-bwcl-color]');
    if (col) { switchTo(col.getAttribute('data-bwcl-color'), col); return; }
    var sole = t.closest('[data-bwcl-sole]');
    if (sole) { switchTo(sole.getAttribute('data-bwcl-sole'), sole); return; }
    var qb = t.closest('[data-bwcl-qty]');
    if (qb) { changeQty(Number(qb.getAttribute('data-bwcl-qty'))); }
  }
  function onQsKey(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(qs.querySelectorAll('a[href],button:not([disabled]),input,[tabindex]:not([tabindex="-1"])'), function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- The Core: per-band sole switch (Leather Sole | Weber Lug Sole) ---------- */
  function ccData(card, key) {
    var a = card.getAttribute('data-' + key);
    if (!a) return null;
    try { return JSON.parse(a); } catch (e) { return null; }
  }
  function setBandSole(band, sole) {
    var lug = sole === 'w';
    if (band.getAttribute('data-sole') === sole) return;
    band.setAttribute('data-sole', sole);
    $$('[data-bwcl-sole-set]', band).forEach(function (b) {
      var on = b.getAttribute('data-bwcl-sole-set') === sole;
      b.classList.toggle('on', on); b.setAttribute('aria-pressed', String(on));
    });
    $$('[data-bwcl-cc]', band).forEach(function (card) {
      var l = ccData(card, 'l'), w = ccData(card, 'w');
      if (!l) return;
      var onLug = lug && !!w, d = onLug ? w : l;
      var soleName = onLug ? 'Weber Lug Sole' : 'Leather Sole';
      var img = $('.bwcl-cc__img', card);
      if (img) {
        if (d.s && img.getAttribute('src') !== d.s) {
          card.classList.add('is-swapping');
          var done = function () { card.classList.remove('is-swapping'); };
          img.addEventListener('load', done, { once: true });
          img.addEventListener('error', done, { once: true });
          setTimeout(done, 1500);
          if (d.ss) img.setAttribute('srcset', d.ss); else img.removeAttribute('srcset');
          img.setAttribute('src', d.s);
        }
        img.alt = card.getAttribute('data-style') + ', ' + card.getAttribute('data-color') + ', ' + soleName;
      }
      $$('[data-bwcl-cc-link]', card).forEach(function (a) { a.setAttribute('href', d.u); });
      var pr = $('[data-bwcl-cc-price]', card); if (pr) pr.textContent = d.p;
      var so = $('[data-bwcl-cc-so]', card); if (so) so.hidden = !!d.a;
      var sl = $('[data-bwcl-cc-sole]', card); if (sl) sl.textContent = (lug && !w) ? 'Leather sole only' : soleName;
      var q = $('[data-bwcl-cqs]', card); if (q) { q.setAttribute('data-bwcl-cqs', d.h); q.setAttribute('data-url', d.u); }
    });
    var live = $('[data-bwcl-band-live]', band);
    if (live) live.textContent = 'Showing ' + (band.getAttribute('data-name') || '') + ' on the ' + (lug ? 'Weber Lug Sole' : 'Leather Sole') + '.';
  }
  // Quick Shop from a Core tile: whichever product (leather or lug) the tile currently shows
  function openCore(btn) {
    var h = btn.getAttribute('data-bwcl-cqs'), u = btn.getAttribute('data-url');
    if (!h || btn.getAttribute('aria-busy') === 'true') return;
    if (open(h)) return;
    btn.setAttribute('aria-busy', 'true');
    getProduct(h).then(function (p) {
      btn.removeAttribute('aria-busy');
      if (!(p && open(h)) && u) window.location.href = u;
    });
  }

  /* ---------- page clicks (delegated) ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target;
    var soleSet = t.closest('[data-bwcl-sole-set]');
    if (soleSet) {
      var band = soleSet.closest('[data-bwcl-band]');
      if (band) setBandSole(band, soleSet.getAttribute('data-bwcl-sole-set'));
      return;
    }
    var cqs = t.closest('[data-bwcl-cqs]');
    if (cqs) { e.preventDefault(); openCore(cqs); return; }
    var trig = t.closest('[data-bwcl-qs]');
    if (trig) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      if (open(trig.getAttribute('data-bwcl-qs'), trig.getAttribute('data-bwcl-worn'), trig.getAttribute('data-bwcl-worn-img'))) e.preventDefault();
      return;
    }
    var pin = t.closest('[data-bwcl-pin]');
    if (pin) {
      e.preventDefault();
      if (mqMobile.matches || !window.matchMedia('(hover: hover)').matches) {
        // touch: tap the dot to Quick Shop (mobile design); on tablet show the card first
        if (mqMobile.matches || pin.parentNode.classList.contains('is-open')) { open(pin.getAttribute('data-bwcl-pin'), pin.getAttribute('data-bwcl-worn'), pin.getAttribute('data-bwcl-worn-img')); }
        else { $$('.bwcl-pin.is-open').forEach(function (x) { x.classList.remove('is-open'); }); pin.parentNode.classList.add('is-open'); }
      } else {
        open(pin.getAttribute('data-bwcl-pin'), pin.getAttribute('data-bwcl-worn'), pin.getAttribute('data-bwcl-worn-img'));
      }
      return;
    }
    // smooth in-page anchors (header is sticky)
    var a = t.closest('a[href^="#bwcl-"]');
    if (a) {
      var target = document.getElementById(a.getAttribute('href').slice(1));
      if (target) {
        e.preventDefault();
        var h = document.querySelector('.header-bar-wrapper');
        var off = (h && getComputedStyle(h).position === 'sticky') ? h.offsetHeight : 0;
        var y = target.getBoundingClientRect().top + window.pageYOffset - off;
        try { window.scrollTo({ top: y, behavior: 'smooth' }); } catch (err) { window.scrollTo(0, y); }
      }
    }
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.bwcl-pin')) $$('.bwcl-pin.is-open').forEach(function (x) { x.classList.remove('is-open'); });
    if (!e.target.closest('.bwcl-tool')) closeTools();
  });

  /* ---------- rails (mobile) ---------- */
  $$('[data-bwcl-rail]').forEach(function (rail) {
    var name = rail.getAttribute('data-bwcl-rail');
    var nav = $('[data-bwcl-railnav="' + name + '"]');
    if (!nav) return;
    var segs = $$('.bwcl-railnav__segs span', nav);
    function upd() {
      var m = rail.scrollWidth - rail.clientWidth;
      var idx = Math.round((m > 0 ? rail.scrollLeft / m : 0) * (segs.length - 1));
      segs.forEach(function (s, i) { s.classList.toggle('on', i === idx); });
    }
    rail.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
    $$('[data-bwcl-dir]', nav).forEach(function (b) {
      b.addEventListener('click', function () {
        var first = rail.children[0];
        var step = first ? first.getBoundingClientRect().width + 10 : 260;
        try { rail.scrollBy({ left: step * Number(b.getAttribute('data-bwcl-dir')), behavior: 'smooth' }); } catch (e) { rail.scrollLeft += step * Number(b.getAttribute('data-bwcl-dir')); }
      });
    });
  });

  /* ---------- filter + sort ---------- */
  var grid = $('[data-bwcl-grid]');
  var cards = grid ? $$('.bwcl-card', grid) : [];
  function closeTools(except) {
    $$('[data-bwcl-tool]').forEach(function (b) {
      if (b === except) return;
      b.setAttribute('aria-expanded', 'false');
      var pop = document.getElementById(b.getAttribute('aria-controls')); if (pop) pop.hidden = true;
    });
  }
  $$('[data-bwcl-tool]').forEach(function (b) {
    b.addEventListener('click', function () {
      var open = b.getAttribute('aria-expanded') !== 'true';
      closeTools(b);
      b.setAttribute('aria-expanded', String(open));
      var pop = document.getElementById(b.getAttribute('aria-controls')); if (pop) pop.hidden = !open;
    });
  });
  root.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeTools(); });
  function applyFilter() {
    var on = $$('[data-bwcl-filter]').filter(function (i) { return i.checked; }).map(function (i) { return i.value; });
    var shown = 0;
    cards.forEach(function (c) { var vis = !on.length || on.indexOf(c.getAttribute('data-bwcl-style')) > -1; c.hidden = !vis; if (vis) shown++; });
    var fc = $('[data-bwcl-fcount]'); if (fc) fc.textContent = on.length ? ' (' + on.length + ')' : '';
    var em = $('[data-bwcl-empty]'); if (em) em.hidden = shown > 0;
  }
  function applySort() {
    var v = ($$('[data-bwcl-sort]').filter(function (i) { return i.checked; })[0] || {}).value || 'featured';
    var list = cards.slice();
    if (v === 'featured') list.sort(function (a, b) { return a.getAttribute('data-bwcl-index') - b.getAttribute('data-bwcl-index'); });
    else list.sort(function (a, b) { var r = a.getAttribute('data-bwcl-title').localeCompare(b.getAttribute('data-bwcl-title')); return v === 'za' ? -r : r; });
    list.forEach(function (c) { grid.appendChild(c); });
  }
  $$('[data-bwcl-filter]').forEach(function (i) { i.addEventListener('change', applyFilter); });
  $$('[data-bwcl-sort]').forEach(function (i) { i.addEventListener('change', applySort); });

  /* ---------- drop alert (Klaviyo client subscription) ---------- */
  $$('[data-bwcl-signup]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input[type="email"]');
      var msg = form.querySelector('[data-bwcl-msg]');
      var btn = form.querySelector('button[type="submit"]');
      var email = (input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        input.setAttribute('aria-invalid', 'true'); msg.textContent = 'Please enter a valid email address.'; input.focus(); return;
      }
      input.removeAttribute('aria-invalid');
      var k = DATA.klaviyo || {};
      btn.disabled = true; msg.textContent = '';
      var body = { data: { type: 'subscription', attributes: { custom_source: k.source || 'Core Loafers landing page', profile: { data: { type: 'profile', attributes: { email: email } } } }, relationships: { list: { data: { type: 'list', id: k.list } } } } };
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(k.company), {
        method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: '2024-10-15' }, body: JSON.stringify(body)
      }).then(function (r) {
        if (!r.ok) throw new Error('status ' + r.status);
        form.innerHTML = '<div class="bwcl-drop__done" role="status"><span class="bwcl-serif">You’re on the list.</span><span>We’ll email you before the next drop.</span></div>';
      }).catch(function () {
        btn.disabled = false; msg.textContent = 'Something went wrong. Please try again.';
      });
    });
  });

  /* ---------- journal film: lazy load + play when visible ---------- */
  $$('[data-bwcl-video]').forEach(function (v) {
    var src = v.getAttribute('data-src');
    if (!src || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    v.muted = true;
    function load() {
      if (!v.getAttribute('src')) { v.setAttribute('src', src); v.setAttribute('preload', 'auto'); }
      var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
    }
    v.addEventListener('error', function () { v.removeAttribute('src'); v.load(); }, { once: true });
    if (!('IntersectionObserver' in window)) { load(); return; }
    new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { if (en.isIntersecting) load(); else if (v.getAttribute('src')) v.pause(); });
    }, { rootMargin: '200px 0px' }).observe(v);
  });
})();
